module.exports = __webpack_public_path__ + "assets/c8ed6e514a18a8d3b40170c213b24d67.png";